<template>
  <div id="classify" >
    <div class="page-box" :style="{backgroundImage: `url(${imgBg})` }">
      <com-header ref="header"/>
      <div class="menu-content classify-menu">
        <h1> {{tagname}}</h1>
        <div class="classify-nav">
          <div class="classify-icon" @click="navIconFun('left')">
            <img src="../../static/image/left.png" alt="">
          </div>
          <div class="nav-scroll">
            <div class="nav-scroll-box" :style="{left: `-${(navPage- 1) * 968}px`}">
              <div :class="{'nav-item nav-item-hover' :item.id === imgRequest.three_phototag_id ,  'nav-item' :item.id !== imgRequest.three_phototag_id}"
                   v-for="item in threeClassify"
                   @click="navClick(item.id)"
              >{{item.tagname}}
              </div>
            </div>
          </div>
          <div class="classify-icon" @click="navIconFun('right')">
            <img src="../../static/image/right.png" alt="">
          </div>
        </div>
      </div>
      <div class="page-box-list-scroll" v-infinite-scroll="load" infinite-scroll-distance="800" infinite-scroll-delay="500">
        <div class="search-content ">
          <com-card :imgList="imgList" :total="imgRequest.total" v-if="imgList.length > 0" @collectCall="collectCall"/>
        </div>
      </div>
    </div>
    <el-backtop target=".page-box-list-scroll"></el-backtop>

  </div>
</template>

<script>
export default {
  name: "classify",
  data(){
    return {
      navDrawer: false,
      imgList: [],
      autoplay: false,
      activeName: '',
      threeClassify: [],
      typeRequest: {
        phototag_id: ''
      },
      navSelect: '',
      navPage: 1,
      imgRequest: {
        size: 9,
        page: 1,
        three_phototag_id: '',
        total: ''
      },
      loading: true,
      screenFlag: false,
      tagname:'',
      collectNum:0,
      imgBg:''
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.typeRequest.phototag_id = this.$route.query.id
      this.getThreeClassify()
      this.tagname = this.navList.filter((item) => this.$route.query.id == item.id)[0].tagname
    }
    this.getImgBg({id: this.$route.query.id })
  },
  methods: {
    getImgBg(params) {
      this.$get('/pc/shop/bgimg', params).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    getThreeClassify() {
      this.$get('/pc/shop/threeClassify', this.typeRequest).then((res) => {
        this.threeClassify = res.data
        this.imgRequest.three_phototag_id = res.data[0].id
        this.getImgList()
      }).catch((error) => {

      })
    },
    navClick(id) {
      this.imgRequest = {
        size: 9,
        page: 1,
        three_phototag_id: id,
        total: ''
      },
        this.imgList = []
      this.getImgList()
    },
    load() {
      if (this.imgRequest.total > this.imgList.length && this.loading) {
        this.loading = false
        this.imgRequest.page = this.imgRequest.page + 1
        this.getImgList()
      }
    },
    navIconFun(type) {
      if (this.threeClassify.length > this.navPage * 8) {
        if (type === 'right') {
          this.navPage++
        }
      }
      if (type === 'left' && this.navPage > 1) {
        this.navPage--
      }
    },
    getImgList() {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass:'el-loading-com'
      });
      this.$get('/pc/shop/threeClassifyPhotoPackage', this.imgRequest).then((res) => {
        loading.close();
        this.loading = true
        this.imgList = [...this.imgList, ...res.data]
        this.imgRequest.total = res.meta.total
      }).catch((error) => {
        this.loading = true
        this.$message.error(error.message);
        loading.close();
      })
    },
    getHandleImg(data,img) {
      if (data.length > 0) {
        let arr = []
        data.forEach((item) => {
          if(item.id !== img.id){
            arr.push( item.url)
          }
        })
        arr.unshift(img.url)
        return arr
      }
      return []
    },
    collectCall(data) {
      this.$refs.header.getCollect()
      this.imgList.forEach((item) => {
        if (item.id === data.id) {
          if (item.iscollect === 0) {
            item.iscollect = 1
            item.collection = Number(item.collection) + 1
          } else {
            item.iscollect = 0
            item.collection = Number(item.collection) - 1
          }
        }
      })
    },
    clickLog(list, img) {
      this.$get('/pc/shop/clickLog', {packageid: list.id, imageid: img.id,phototag_id:window.getRequest().id,three_phototag_id:this.imgRequest.three_phototag_id}).then((res) => {
      })
    }
  }
}
</script>

<style scoped lang="less">
.page-box {
  height: 100vh;
  background-size: cover;
}
.classify-nav{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1080px;
  height: 44px;
  margin: 10px  auto;
  border: 3px solid #E8B45E;
  border-radius: 32px;
}
.classify-icon{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 44px;
}
.classify-icon img{
  width: 13px;
  height: 23px;
}
.nav-scroll{
  display: flex;
  align-items: center;
  position:relative;
  width: 960px;
  height: 44px;
  overflow-x:auto;
  border-left:1px solid #E8B45E;
  border-right:1px solid #E8B45E;
}
.nav-scroll-box{
  display: flex;
  align-items: center;
  position:absolute;
  top:0;
  left:0;
}
.nav-item{
  width: 120px;
  height: 44px;
  line-height: 44px;
  font-size:18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  border-right:1px solid #E8B45E;
  text-align:center;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.nav-item-hover{
  width: 120px;
  color:#222222;
  background: #E8B45E;
  border-right:1px solid #E8B45E;

}
.nav-scroll::-webkit-scrollbar {display:none}

</style>



// WEBPACK FOOTER //
// src/views/classify.vue